import React from 'react';
import cn from 'classnames';
import styles from './ColorSplotch.module.scss';

interface SplotchProps {
  color: string;
  className?: string;
}

export default function ColorSplotch({ color, className }: SplotchProps) {
  return <span className={cn(styles.splotch, className)} style={{ backgroundColor: color }} />;
}
